import { ReduxState } from 'redux/root-reducer';

export const selectRouteBranchParentUrl = (state: ReduxState) => state.routerBranch.parentURL;

export const selectRouteBranchHistory = (state: ReduxState) => state.routerBranch.locationKeyHistory;
